import { useState } from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";
import Wrapper from "../../helpers/Wrapper";
import Logo from "../../assets/images/SVG/logo-outline.svg";
import MediaQuery, { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import { SwiperButtonNext } from "../../components/button/SwiperButton";
import axios from "axios";
import MainParticles from "../../components/Particles/MainParticles";

function EarlyAccess() {
  const [email, setEmail] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [name, setName] = useState("");
  const [nameValid, setNameValid] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneValid, setPhoneValid] = useState(false);
  const navigate = useNavigate();
  const isPortrait = useMediaQuery({
    query: "(orientation: portrait)",
  });
  const isTabletOrMobile = useMediaQuery({ maxWidth: 767 });
  const swiper = useSwiper();
  const handleSubmit = (event: any) => {
    event.preventDefault();
    // Perform form submission logic here
  };

  function validateEmailInterceptor(e: any) {
    setEmail(e.target.value);
    var filter =
      /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    let pass = String(e.target.value).search(filter) != -1;
    if (pass) {
      setEmailValid(true);
      return true;
    } else {
      setEmailValid(false);
      return false;
    }
  }
  function validateNameInterceptor(e: any) {
    setName(e.target.value);

    if (e.target.value.length > 3) {
      setNameValid(true);
      return true;
    } else {
      setNameValid(false);
      return false;
    }
  }
  function validatePhone(e: any) {
    setPhone(e.target.value);
    if (String(e.target.value).length == 10) {
      setPhoneValid(true);
    } else {
      setPhoneValid(false);
      return false;
    }
  }

  function submit() {
    if (emailValid && nameValid && phoneValid) {
      axios
        .post("https://submit-form.com/iapMVxvl", {
          email,
          name,
          phone,
        })
        .then(function (response) {
          navigate("/success");
        })
        .catch(function (response) {
          alert("Form not submitted. Please check internet connection.");
        });
    } else if (!phoneValid) {
      alert("10 digit dialing");
    }
  }

  return (
    <Wrapper>
      <Container>
        <EarlyAccessContainerLeft>
          <EarlyAccessLeft>
            <EarlyAccessLeftTop>
              {isTabletOrMobile && (
                <section>
                  <img
                    style={{ textAlign: "center" }}
                    className="logo-img top-img"
                    src={Logo}
                    onClick={() => navigate("/")}
                  />
                </section>
              )}
              <div className="early_access_container">
                {!isTabletOrMobile && (
                  <h1>
                    Request <br />
                    early access{" "}
                  </h1>
                )}
                {isTabletOrMobile && (
                  <h1 style={{ textAlign: "center" }}>
                    Request <br />
                    early access{" "}
                  </h1>
                )}

                {!isTabletOrMobile && (
                  <p className="telem__slogan">Data should be local-first.</p>
                )}

                {isTabletOrMobile && (
                  <p className="telem__slogan">Data should be local-first.</p>
                )}

                <div className="swiper_container">
                  <Swiper
                    spaceBetween={50}
                    slidesPerView={1}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    allowTouchMove={false}
                  >
                    <SwiperSlide>
                      {" "}
                      <form onSubmit={handleSubmit} className="input__wrap">
                        <input
                          className="email__input"
                          type="email"
                          placeholder="Your email..."
                          onChange={(e) => {
                            validateEmailInterceptor(e);
                          }}
                          required
                        />

                        {emailValid ? (
                          <SwiperButtonNext text="Request Early Access" />
                        ) : (
                          <button
                            onClick={() => {
                              alert("Valid Email Required");
                            }}
                          >
                            Request Early Access
                          </button>
                        )}
                      </form>
                    </SwiperSlide>
                    <SwiperSlide>
                      {" "}
                      <form onSubmit={handleSubmit} className="input__wrap">
                        <input
                          className="email__input"
                          type="text"
                          placeholder="Your Full Name..."
                          onChange={(e) => {
                            validateNameInterceptor(e);
                          }}
                          required
                        />
                        {nameValid ? (
                          <SwiperButtonNext text="Next" />
                        ) : (
                          <button
                            onClick={() => {
                              alert("Full Name Required");
                            }}
                          >
                            Next
                          </button>
                        )}
                      </form>
                    </SwiperSlide>
                    <SwiperSlide>
                      {" "}
                      <form onSubmit={handleSubmit} className="input__wrap">
                        <input
                          className="email__input"
                          type="number"
                          placeholder="Your Phone Number..."
                          onChange={(e) => {
                            validatePhone(e);
                          }}
                          required
                        />
                        <button
                          onClick={() => {
                            submit();
                          }}
                        >
                          Submit
                        </button>
                      </form>
                    </SwiperSlide>
                  </Swiper>
                  <div className="disclaimer">
                    <p>
                      By clicking "Request early access", you agree to or{" "}
                      <u>Terms of Service</u> and <u>Privacy Policy</u>. We'll
                      occasionally send you account related emails.
                    </p>
                  </div>
                </div>
              </div>
            </EarlyAccessLeftTop>
          </EarlyAccessLeft>
        </EarlyAccessContainerLeft>

        <EarlyAccessContainerRight>
          {!isTabletOrMobile && (
            <section className="logo-img-large-container">
              <img className="logo-img-large" src={Logo} />
            </section>
          )}
        </EarlyAccessContainerRight>
      </Container>
      <MainParticles />
    </Wrapper>
  );
}

export default EarlyAccess;

const EarlyAccessContainerLeft = styled.div`
  display: flex;
  /* padding: 10px 0 0px 0; */
  color: white;
  background-color: #171717;
  width: 500px;
  /* overflow-x: hidden; */
  height: 100vh;
  .disclaimer {
    display: block;
    font-size: 14px;
    /* background-color: #171717; */
    padding-top: 50px;
    width: 320px;

    u {
      :hover {
        cursor: pointer;

        text-decoration: none;
      }
    }
  }

  @media (min-width: 767px) and (max-width: 991px) {
    width: 50%;
  }

  @media (max-width: 767px) {
    width: 100%;
    overflow-x: hidden;
    text-align: center;
  }
`;

const Container = styled.div`
  display: flex;
`;

const EarlyAccessLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  width: 300px;

  background-color: #171717;

  @media (min-width: 767px) {
    width: 100%;
    /* height: 100%; */
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 100%;
  }
`;

const EarlyAccessLeftTop = styled.div`
  align-items: center;
  padding: 50px 0 50px 0;

  > section {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 20px;

    > p {
      margin-left: 10px;
    }
  }

  h1 {
    font-size: 52px;
    align-items: left;
    text-align: left;
    margin-bottom: 100px;
    margin: 47px 0px 47px 9px;
    width: 320px;
  }

  .telem__slogan {
    font-size: 18px;
    line-height: 1.55;
    width: 320px;
    margin: 47px 0px 47px 10px;
  }

  .input__wrap {
    display: flex;
    flex-direction: column;
  }

  .email__input {
    display: block;
    width: 300px;
    font-weight: 700;
    align-items: left;
    padding: 12px 24px;
    margin: 10px;
    text-align: center;
    color: white;
    border-radius: 12px !important;
    background-color: #0a0a0a;
    padding: 0.5rem;
    border: 0px;
    line-height: 24px;
    font-size: 15px;
    border: double 2px transparent;
    border-radius: 6px;
    border: double 2px #36add8;

    background-image: linear-gradient(#0a0a0a, #0a0a0a),
      linear-gradient(to right, #36add8, #1e3b8b);
    background-origin: border-box;
    transition: background-color 0.2s ease-out 0s;
    :focus {
      outline: none;
      border: double 2px #36add8;
    }
  }

  .input__wrap > button {
    font-weight: bold;
    height: 100%;
    width: 320px;
    color: aliceblue;
    border-radius: 12px;
    border: none;
    background-image: linear-gradient(
      to right,
      #1e3b8b 0%,
      #36add8 51%,
      #1e3b8b 100%
    );
    background-size: 200% auto;
    letter-spacing: 0.5px;
    font-family: "Poppins-Bold";
    border: 0px;
    display: block;
    font-size: 14px;
    line-height: 24px;
    padding: 12px 24px;
    margin: 10px;
    transition: 0.8s ease-out 0s;
    cursor: pointer;
    :hover {
      background-position: right center;
      opacity: 0.8;
    }
  }
`;

const EarlyAccessContainerRight = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;

  > section {
    flex: 1;
    align-self: stretch;

    width: 100%;
  }

  > section > img {
    display: flex;
    margin: 25px;
    cursor: pointer;
  }

  > section > p {
    margin-left: 20px;
    font-size: 24px;
    color: white;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;
